'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.FeatureToggle'];
module.exports = angular.module('AVRO.Common.ApplicationManagement', dependencies).value('ApplicationManagementConstants', require('./constants/ApplicationManagementConstants')).factory('ApplicationManagementService', require('./services/ApplicationManagementService'));